import { gql } from '@apollo/client';

const DASHBOARD_GET_PRODUCT_APP = gql`
  query DashboardGetProductApp($applicationId: ID!) {
    getProductApp(applicationId: $applicationId) {
      id
      type
      subType
      exchange
      products {
        id
        planId
        planExternalId
        fullPremium
        region
        planVersion
        subsidizedPremium
        effectiveDate
        planVariant
      }
      applicants {
        id
        externalId
        personId
        isFiler
        type
      }
      statuses {
        createdAt
        deletedAt
        status
      }
      subsidies {
        id
        amountElected
        amountEligible
        productId
      }
      enrollmentGroups {
        product {
          id
          planId
          planExternalId
          fullPremium
          region
          planVersion
          subsidizedPremium
          effectiveDate
          planVariant
        }
        applicants {
          id
          externalId
          personId
          isFiler
          type
        }
        subsidy {
          id
          amountElected
          amountEligible
          productId
        }
      }
    }
  }
`;

export default DASHBOARD_GET_PRODUCT_APP;
